import React, { useContext } from 'react';

import { useSettings as useSettingsService } from 'services/settings';

const SettingsContext = React.createContext(null);

export function SettingsContextProvider({ children }) {
  const {
    data: settings = {},
    refetch: reloadSettings,
    isLoading: isSettingsLoading
  } = useSettingsService();

  const developmentPipelines =
    settings?.value?.filter(({ name }) => name.indexOf('Development - ') !== -1) ?? [];
  const productionPipelines =
    settings?.value?.filter(({ name }) => name.indexOf('Development - ') === -1) ?? [];

  return (
    <SettingsContext.Provider
      value={{
        settings,
        pipelines:
          process.env.REACT_APP_ENV === 'prod' ? productionPipelines : developmentPipelines,
        reloadSettings,
        isSettingsLoading
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error('useSettings must be used within a SettingsContextProvider');
  }

  return context;
}
